import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./index.css";
import Image from "next/image";
import { AddToCartService } from "../../../services/cart";
import ShareIcon from "@mui/icons-material/Share";
import Coin from "../../../assets/stcoin.png";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import { useRouter } from "next/navigation";
import { Guide } from "./Guide";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "./MaxServiceAlert";
import ShareService from "../share/ShareService";
import BestPaired from "./BestPaired";

interface MobileCardProps {
  id: any;
  cid: any;
  url: any;
  heading: any;
  subHeading: any;
  finalPrice: any;
  discount: any;
  price: any;
  addOn: any;
  serviceDetails: any;
  handleViewDetails: any;
  min: any;
  coin: any;
  handleOpenViewDetailsRsOne: any;
  updateCard: any;
  setUpdateCard: any;
  productDetailsAvailable: any;
  reloadViewDetailsItem: any;
  makeYourOwnPackage: boolean;
  handleEditPackage: any;
  recommendedServices: any;
  handleViewDetailsBestPaired: any;
  aboutList: any;
  serviceCharge: any;
  productCost: any;
  specialPrice: any;
  specialMessage: any;
}

export const MobileCard: React.FC<MobileCardProps> = ({
  id,
  cid,
  url,
  heading,
  subHeading,
  finalPrice,
  discount,
  price,
  addOn,
  serviceDetails,
  handleViewDetails,
  min,
  coin,
  handleOpenViewDetailsRsOne,
  updateCard,
  setUpdateCard,
  productDetailsAvailable,
  reloadViewDetailsItem,
  makeYourOwnPackage,
  handleEditPackage,
  recommendedServices,
  handleViewDetailsBestPaired,
  aboutList,
  serviceCharge,
  productCost,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [value, setVaue] = useState(1);
  const [openMaxService, setOpenMaxService] = useState(false);
  const [openShareDrawer, setOpenShareDrawer] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const router = useRouter();
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();

  const hours = Math.floor(min / 60);
  const minutes = min % 60;
  const formattedHours = hours < 10 ? `0${hours}` : hours;

  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, cid, id, setUpdateCard]);

  const handleClickButton = async () => {
    setIsLoading(true);
    // console.log(id);
    if (addOn == true) {
      handleOpenViewDetailsRsOne();
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        url,
        aboutList,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson.count);
        setIsClicked(true);
        reloadViewDetailsItem();
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadViewDetailsItem();
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleReferEarnNavigate = (e: any) => {
    e.preventDefault();
    setOpenShareDrawer(true);
    // router.push("/refer&earn");
  };

  return (
    <>
      <Box
        sx={{
          padding: "0.5rem",
          margin: "0.5rem auto",
          width: "100%",
        }}
      >
        {/* <Box
          //   className="card-container"
          key={"serviceCard" + id}
          sx={{
            display: "flex",
            //   border: "1px solid black",
            //   minHeight: "15rem",
          }}
        > */}
        <Box sx={{ padding: "0.5rem", width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Box>
                <Image
                  src={url}
                  alt="icon"
                  style={{
                    objectFit: "cover",
                    width: "4rem",
                    height: "4rem",
                    minHeight: "4rem",
                    maxWidth: "4rem",
                    borderRadius: "100%",
                  }}
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </Box>
              &nbsp; &nbsp;
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    marginBottom: "5px",
                    textTransform: "capitalize",
                  }}
                >
                  {heading}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", textTransform: "capitalize" }}
                >
                  {subHeading}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ paddingLeft: "1rem" }}>
              {isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "115px",
                    background: "none",
                    borderRadius: "10rem",
                    border: "1px solid #15741a",
                    height: "32px",
                  }}
                >
                  <CircularProgress size="25px" color="success" />
                </Box>
              ) : isClicked ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    width: "115px",
                    height: "32px",
                    background: "#15741a",
                    borderRadius: "10rem",
                    color: "white",
                  }}
                >
                  <RemoveIcon
                    onClick={handleValueDecrease}
                    sx={{ cursor: "pointer" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {value}
                  </Typography>
                  <AddIcon
                    onClick={handleValueIncrease}
                    sx={{ cursor: "pointer" }}
                  />
                </Box>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "11px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    padding: "6px 20px",
                    borderRadius: "10rem",
                    width: "115px",
                    height: "32px",
                    boxShadow: "none",
                    background: "#15741a",
                  }}
                  color="success"
                  onClick={handleClickButton}
                >
                  Add to Cart
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              margin: "12px 0px 5px",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {currencyCode}
              {finalPrice?.toLocaleString()}/-
            </Typography>
            <Typography
              variant="body2"
              sx={{
                paddingLeft: "10px",
                // color: "#808080ab",
                color: "gray",
                textDecoration: "line-through",
              }}
            >
              {currencyCode}
              {price?.toLocaleString()}/-
            </Typography>
            &nbsp;&nbsp;
            <span style={{ color: "#FFBF00" }}> | </span>
            <Typography
              variant="body2"
              sx={{ paddingLeft: "10px", color: "#15741a" }}
            >
              Save{" "}
              <span style={{ fontWeight: "bold" }}>
                {currencyCode}
                {discount?.toLocaleString()}/-
              </span>
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              margin: "5px 0px",
            }}
          >
            <WatchLaterIcon sx={{ fontSize: "18px", color: "#15741a" }} />
            <Typography
              variant="caption"
              sx={{
                paddingLeft: "8px",
                fontWeight: "bold",
              }}
            >
              {formattedHours} hr : {minutes} mins
            </Typography>
          </Box>

          <Box
            sx={{
              height: "auto",
              margin: "8px 0px",
              maxHeight: "auto",
              // overflow: "auto",
            }}
          >
            {serviceDetails?.map((item: any, index: number) => (
              <Box sx={{ display: "flex", alignItems: "start" }} key={index}>
                <CheckIcon sx={{ color: "#15741a", padding: "5px" }} />
                <Typography variant="caption">{item}</Typography>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              margin: "5px 0px",
            }}
          >
            <Image
              src={Coin}
              alt="icon"
              style={{
                objectFit: "cover",
                width: "1.4rem",
                height: "1.4rem",
                borderRadius: "0.5rem",
              }}
              width={500}
              height={500}
              loading="lazy"
            />
            <Typography variant="caption" sx={{ paddingLeft: "8px" }}>
              {coin} Coin Cashback
            </Typography>
          </Box>
        </Box>
        {/* </Box> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            padding: "0px 0.5rem",
          }}
        >
          {makeYourOwnPackage ? (
            <Button
              variant="outlined"
              aria-hidden="false"
              sx={{
                fontSize: "11px",
                textTransform: "capitalize",
                fontWeight: "bold",
                padding: "6px 20px",
                borderRadius: "10rem",
                width: "115px",
                boxShadow: "none",
              }}
              color="success"
              onClick={handleEditPackage}
            >
              Edit Package
            </Button>
          ) : (
            <Button
              variant="outlined"
              sx={{
                fontSize: "12px",
                textTransform: "capitalize",
                fontWeight: "bold",
                padding: "4px 16px",
                borderRadius: "10rem",
                width: "auto",
                boxShadow: "none",
              }}
              color="success"
              onClick={handleViewDetails}
            >
              View Details
            </Button>
          )}
          &nbsp; &nbsp;
          <Button
            variant="outlined"
            color="warning"
            onClick={handleReferEarnNavigate}
            sx={{
              fontSize: "12px",
              textTransform: "capitalize",
              fontWeight: "bold",
              padding: "4px 16px",
              borderRadius: "10rem",
              width: "auto",
              boxShadow: "none",
              color: "#15741a",
              border: "1px solid #FFBF00",
            }}
          >
            <ShareIcon sx={{ paddingRight: "5px", fontSize: "20px" }} />
            Share
          </Button>
          &nbsp; &nbsp;
          {productDetailsAvailable == true && <Guide serviceId={id} />}
        </Box>
      </Box>
      {isClicked && recommendedServices?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            overflow: "scroll",
            padding: "0.5rem",
            background: "#e6e3e390",
          }}
        >
          {recommendedServices?.map((item: any, index: any) => (
            <Box key={index}>
              <BestPaired
                addOn={item?.addOn}
                id={item?.id}
                cid={item?.cid}
                url={item?.coverImage.secureHttpPath}
                heading={item?.name}
                subHeading={item?.subHeading}
                price={item?.mrp}
                aboutList={item?.aboutList}
                serviceCharge={item?.serviceCharge}
                productCost={item?.productCost}
                min={item?.min}
                finalPrice={item?.amount}
                specialPrice={item?.specialPrice}
                specialMessage={item?.specialMessage}
                handleViewDetailsBestPaired={() =>
                  handleViewDetailsBestPaired(item)
                }
                updateCard={updateCard}
                setUpdateCard={() => setUpdateCard(false)}
                reloadViewDetailsItem={reloadViewDetailsItem}
                productDetailsAvailable={item?.productDetailsAvailable}
                handleOpenViewDetailsRsOne={() =>
                  handleOpenViewDetailsRsOne(item, index)
                }
              />
            </Box>
          ))}
        </Box>
      )}
      <Divider />
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
      <ShareService
        drawerOpen={openShareDrawer}
        closeDrawer={() => setOpenShareDrawer(false)}
      />
    </>
  );
};

export default MobileCard;
